export function getDescriptionSnippet(
    description: string,
    searchQuery: string
): { snippet: string; prefix: string; suffix: string } {
    const matchIndex = description.toLowerCase().indexOf(searchQuery.toLowerCase());
    const snippetPadding = 40;
    let start = Math.max(0, matchIndex - snippetPadding);
    let end = Math.min(description.length, matchIndex + searchQuery.length + snippetPadding);

    if (start > 0) {
        const spaceIndex = description.lastIndexOf(' ', start);
        if (spaceIndex > start - 20) start = spaceIndex + 1;
    }
    if (end < description.length) {
        const spaceIndex = description.indexOf(' ', end);
        if (spaceIndex > 0 && spaceIndex < end + 20) end = spaceIndex;
    }

    return {
        prefix: start > 0 ? '...' : '',
        suffix: end < description.length ? '...' : '',
        snippet: description.substring(start, end)
    };
}
